var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSettings = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "settings_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#settings_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#87858B",
  d: "M9.25 14.665h-2.5a.623.623 0 0 1-.432-.166.664.664 0 0 1-.217-.417l-.2-1.55a2.524 2.524 0 0 1-.408-.2 5.461 5.461 0 0 1-.375-.25l-1.45.6a.746.746 0 0 1-.467.017.62.62 0 0 1-.367-.284l-1.233-2.15a.626.626 0 0 1-.083-.466.64.64 0 0 1 .25-.4l1.25-.95A1.592 1.592 0 0 1 3 8.224v-.45c0-.073.005-.148.017-.225l-1.25-.95a.64.64 0 0 1-.25-.4.626.626 0 0 1 .083-.467l1.233-2.15a.524.524 0 0 1 .359-.292.815.815 0 0 1 .475.025l1.45.6c.122-.089.25-.172.383-.25.133-.077.267-.144.4-.2l.2-1.55a.664.664 0 0 1 .217-.416.623.623 0 0 1 .433-.167h2.5a.664.664 0 0 1 .65.583l.2 1.55c.144.056.28.123.408.2.128.078.253.161.375.25l1.45-.6a.746.746 0 0 1 .467-.016.62.62 0 0 1 .367.283l1.233 2.15c.089.144.117.3.083.467a.64.64 0 0 1-.25.4l-1.25.95c.011.077.017.152.017.225v.45a.815.815 0 0 1-.034.225l1.25.95a.64.64 0 0 1 .25.4.626.626 0 0 1-.083.466L13.151 12.4a.655.655 0 0 1-.375.291.732.732 0 0 1-.475-.008l-1.417-.6c-.122.089-.25.172-.383.25a3.353 3.353 0 0 1-.4.2l-.2 1.55a.664.664 0 0 1-.217.417.623.623 0 0 1-.433.166Zm-1.216-4.333c.645 0 1.195-.228 1.65-.683a2.248 2.248 0 0 0 .684-1.65c0-.645-.228-1.195-.684-1.65a2.248 2.248 0 0 0-1.65-.684 2.24 2.24 0 0 0-1.658.684 2.262 2.262 0 0 0-.675 1.65c0 .644.225 1.194.675 1.65a2.24 2.24 0 0 0 1.658.683Z"
}))));
export default SvgSettings;